export default "__VITE_ASSET__DgfqXfdG__"